import Bloglist from '../components/Bloglist';
import { useState, useEffect } from 'react';
const Poems = () => {
    const [posts, setPosts] = useState(null); 
    const [isPending, setIsPending] = useState(true); 
    const [error, setError] = useState(null); 

    // Fetch data using useEffect hook and fetch api 
    useEffect(() => {
        const fetchPosts = async () => {
            try{
                const response = await fetch('https://siteadeyemiwrites.herokuapp.com/api/posts')
                const json = await response.json()
                if (response.ok) {
                    setPosts(json);
                    setIsPending(false);
                }
                else{
                    setError(true);
                }
            }
            catch(err){
                setIsPending(false);
                setError(err)
            }
            
        }
        fetchPosts();
    }, [])
    
    return ( 
        <div className="poem-component">
            <h1 className="poem-component-title">Poem Library</h1>
            <div className="search">           
                <input type="search" name="" id="" placeholder="Search through poems..." />
            </div>

            <div className="poem-map">
                {isPending && <div> Loading.... </div>}
               {posts && <Bloglist posts={posts.filter((post)=> post.kind === "poem")}/>}
               {error && <div> Couldn't fetch the requested data </div>}
            </div>
        </div>
        
     );
}
 
export default Poems;
